module.exports = __webpack_public_path__ + "faq/img/exit.8df5f087.png";